import type {IssueArtifact} from './types'

export interface ArtifactReorder {
  afterNumber: number | undefined
  fromIndex: number
  toIndex: number
}

export function computeArtifactReorder(
  artifacts: IssueArtifact[],
  movedNumber: number,
  targetNumber: number,
  isBefore: boolean,
): ArtifactReorder | null {
  const fromIndex = artifacts.findIndex(artifact => artifact.number === movedNumber)
  if (fromIndex === -1) return null

  const remainingArtifacts = [...artifacts]
  remainingArtifacts.splice(fromIndex, 1)

  const targetIndex = remainingArtifacts.findIndex(artifact => artifact.number === targetNumber)
  if (targetIndex === -1) return null

  const toIndex = isBefore ? targetIndex : targetIndex + 1
  if (toIndex === fromIndex) return null

  return {
    afterNumber: toIndex === 0 ? undefined : remainingArtifacts[toIndex - 1]?.number,
    fromIndex,
    toIndex,
  }
}
